import type { ASDClient } from '@vgtv/asd-client';

import { config } from '../config';

let client: ASDClient;

export const getASDClient = async (userId: string, callback: () => void) => {
  if (!client) {
    const { ASDClient } = await import('@vgtv/asd-client');

    client = new ASDClient({
      url: config.asd.eventhub.rootUrl,
      token: config.asd.eventhub.clientToken,
      maxSessions: config.asd.maxSessions,
      uniqueId: userId,
      interval: 5000,
      callback,
    });
  }

  return client;
};
